"use client";

import React from "react";
import { CTACornerButton } from "@/shadcn/ui/corner-button";
import { PageTrademania2Schema } from "@/sanity/pages/PageTrademania2Template";
import { VideoFrame } from "@/components/trademania-2/Hero";
import { Chip, CountdownBox, FadeUp, Highlight, RevealWords, revealLines } from "@/components/trademania-2/shared";

import arc from "@/public/trademania-2/final-arc.svg";
import notch from "@/public/trademania-2/final-notch.svg";

export default function LastCTA({ data }: { data: PageTrademania2Schema }) {
  return (
    <VideoFrame
      video={data?.lastVideo}
      poster={data?.lastPoster}
      phoneStrip
      className="flex flex-col lg:h-[117.75rem] lg:flex-row lg:justify-center lg:rounded-[8px]"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={arc.src}
        alt=""
        aria-hidden
        className="pointer-events-none absolute bottom-[-.54%] left-1/2 top-[5.51%] hidden h-[95.03%] w-[258.876rem] max-w-none -translate-x-1/2 lg:block"
      />
      {/* tab hanging from the section above */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={notch.src}
        alt=""
        aria-hidden
        width={560}
        height={36}
        className="absolute left-1/2 top-0 hidden h-[4.5rem] w-[70rem] max-w-none -translate-x-1/2 rotate-180 lg:block"
      />

      {/* phones: below the 16:9 video strip, as in the hero; chip 16px, title 12px, copy 20px,
          CTA 20px, countdown */}
      <div className="relative z-[1] flex w-full flex-col items-center gap-[2rem] px-[2rem] pb-[4rem] pt-[2.5rem] lg:w-[108.5rem] lg:gap-[3.25rem] lg:px-0 lg:pb-[6rem] lg:pt-[16.375rem]">
        <Chip text={data?.lastChip} theme="glass" />
        <div className="flex w-full flex-col items-center gap-[2.5rem] lg:gap-[3.5rem]">
          <div className="flex w-full flex-col items-center gap-[2.5rem]">
            <div className="flex w-full flex-col items-center gap-[1.5rem] lg:gap-[3.25rem]">
              <h2
                ref={revealLines}
                data-reveal
                className="w-full text-center font-owners text-[4.75rem] font-medium uppercase leading-none tracking-[.01em] text-white lg:text-[11rem] lg:leading-[.94]">
                <RevealWords text={data?.lastTitle} />{" "}
                {data?.lastTitleHighlight && (
                  <Highlight theme="dark" className="italic text-[#D9F9B9]">
                    <RevealWords text={data.lastTitleHighlight} />
                  </Highlight>
                )}
              </h2>
              {data?.lastText && (
                <FadeUp className="w-full lg:w-[94.5rem]">
                  <p className="text-center font-geist text-[2.5rem] font-medium leading-[1.4] text-white/80 lg:whitespace-pre-line lg:leading-[1.5]">
                    {/* the last two words share a non-breaking space, so the closing word never sits alone */}
                    {data.lastText.replace(/ (\S+)\s*$/, " $1")}
                  </p>
                </FadeUp>
              )}
            </div>
            {data?.lastCTA && (
              <FadeUp className="w-full lg:w-auto" delay={0.1}>
                <CTACornerButton data={data.lastCTA} />
              </FadeUp>
            )}
          </div>
          <FadeUp className="flex w-full justify-center" delay={0.2}>
            <CountdownBox label={data?.eventDateLabel} target={data?.eventDate} />
          </FadeUp>
        </div>
      </div>
    </VideoFrame>
  );
}
